module.exports = __webpack_public_path__ + "media/images/fire-alert-c878fe6de69e1803df3069b6b55ad572.svg";